import { generateShortId } from '..'
import { LiveData, LivePlaceTimes } from './LiveData'
import { Route, RouteTimestamps } from './Route'

export interface RouteLoggedTimestamps extends RouteTimestamps {
  logged: number;
}

export interface RouteLogged extends Route {
  masterId: string;
  placesLive: LivePlaceTimes[];
  timestamps: RouteLoggedTimestamps;
}

export const RouteLogged = (route: Route, liveData: LiveData): RouteLogged => {
  return {
    ...route,
    masterId: route.id,
    id: generateShortId(),
    placesLive: liveData.places,
    geometry: { legs: [] },
    timestamps: {
      ...route.timestamps,
      logged: new Date().getTime()
    }
  }
}